import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { SUI, Dropdown } from 'shared/ui'
import { propFunc } from 'util/functions'
import { isEmpty } from 'util/arrays'

import Mailbox from './SelectedMailbox'
import MailboxItem from './MailboxItem'

const buildOptions = (mailboxes, onClick) => {
  return mailboxes.filter(e => !!e).map(m => ({
    key: m.id,
    content: <MailboxItem mailbox={m} />,
    onClick: propFunc(onClick, m.id),
    value: m.id,
  }))
}

const mailboxStyle = () => theme => css`
  margin-left: ${theme.spacing['3']};
`

const MailboxDropdown = ({ className, onClick, mailbox, mailboxes }) => {
  return (
    <SUI>
      {isEmpty(mailboxes) ? (
        <Mailbox mailbox={mailbox} css={mailboxStyle} />
      ) : (
        <Dropdown
          className={className}
          options={buildOptions(mailboxes, onClick)}
          scrolling
          trigger={<Mailbox mailbox={mailbox} />}
        />
      )}
    </SUI>
  )
}

export default styled(MailboxDropdown)`
  &&& {
    align-items: center;
    color: ${props => props.theme.color.primary.brand};
    cursor: pointer;
    display: inline-flex;
    margin-left: ${props => props.theme.spacing['3']};

    .dropdown {
      &.icon {
        /* SUI override for a bigger caret thats closer to icon */
        font-size: ${props => props.theme.fontSize.small} !important;
        margin-left: ${props => props.theme.spacing['4']} !important;
      }
    }
  }
`
